import axios from "axios";

const getGrupo = async () => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const userData = { nic: formattedNic, token: token, serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover") };

  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Mangueras/GetGrupoMangueras`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const GrupoMangueras = {
  getGrupo,
};

export default GrupoMangueras;
